import { http, type HttpClient } from './core/http-client';
import type {
  AnalyticsFilterOptions,
  BusinessDetail,
  BusinessRow,
  DetailFilters,
  ListFilters,
  ListMeta,
  OrganisationDetail,
  OrganisationRow,
  Overview,
  OverviewFilters,
  StaffAccess,
} from './models';

export interface ListPage<T> {
  items: T[];
  meta: ListMeta;
}

// Business analytics: super admins, and admins a super admin switched on. Not tenant-scoped.
export class PlatformAnalyticsService {
  constructor(private readonly http: HttpClient) {}

  // Which switched-on staff areas the signed-in staff member can open.
  myAccess = () => this.http.get<StaffAccess>('/admin/me/access');

  filterOptions = () => this.http.get<AnalyticsFilterOptions>('/admin/analytics/filters');

  overview = (filters: OverviewFilters) =>
    this.http.get<Overview>('/admin/analytics/overview', { query: { ...filters } });

  businesses = (filters: ListFilters) =>
    this.list<BusinessRow>('/admin/analytics/businesses', filters);

  organisations = (filters: ListFilters) =>
    this.list<OrganisationRow>('/admin/analytics/organisations', filters);

  business = (id: string, filters: DetailFilters) =>
    this.http.get<BusinessDetail>(`/admin/analytics/businesses/${id}`, { query: { ...filters } });

  organisation = (id: string) =>
    this.http.get<OrganisationDetail>(`/admin/analytics/organisations/${id}`);

  private list<T>(path: string, filters: ListFilters): Promise<ListPage<T>> {
    return this.http.getList<T, ListMeta>(path, { query: { ...filters } });
  }
}

export const platformAnalyticsService = new PlatformAnalyticsService(http);
